var _a;
import Immutable from 'seamless-immutable';
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { AppConstant } from 'constants/app.constant';
var initialState = Immutable({
    locale: '',
    formattedMessages: {}
});
var actions = {
    setLocale: createAction('SET_LOCALE'),
    setFormattedMessages: createAction('SET_FORMATTED_MESSAGES')
};
var reducer = handleActions((_a = {},
    _a[actions.setLocale] = function (state, _a) {
        var payload = _a.payload;
        return state.set('locale', payload);
    },
    _a[actions.setFormattedMessages] = function (state, _a) {
        var payload = _a.payload;
        return state.set('formattedMessages', Immutable.merge(state.formattedMessages, payload));
    },
    _a), initialState);
var getLanguageState = function (state) { return state[AppConstant.reduxResources.LANGUAGE_STATE]; };
var selectors = {
    getLocale: createSelector(getLanguageState, function (state) { return state.locale; }),
    getUsingFormattedMessages: createSelector(getLanguageState, function (state) { return state.getIn(['formattedMessages', state.locale]) || Immutable({}); })
};
export { actions as languageActions, reducer as languageReducer, selectors as languageSelectors };
export { initialState as languageInitialState };
